window._mode='front';window._protocol='https://';window._domain='camping.ribeauville.fr';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/prima/';window._api='/api/v2/';
import Interface from 'theme/index.js';
Interface();